// extracted by mini-css-extract-plugin
module.exports = {"rating":"sl","numberOfStars":"tl"};